import Store from '@/store/index'

export const ButtonShow = (value: string) => {
  const buttonShow = !!Store.state.buttonList.find((item: any) => value === item.butCode)
  return buttonShow
}
